import styled from 'styled-components';
import { media } from '../../../../../../styles-helper';

const OwnBtn = styled.a`
  display: inline-block;
  width: 180px;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  line-height: 60px;
  color: #f44336;
  vertical-align: top;
  font-size: 14px;
  transition: 0.3s;

  &:hover {
    font-size: 15px;
    transition: 0.2s;
  }

  ${media.phone`
    width: 108px;
    line-height: 50px;
    font-size: 12px;

    &:hover {
      font-size: 13px;
    }
  `}
`;

const HeaderOwn = OwnBtn.withComponent('div').extend`
  font-size: 14px;
  font-weight: bold;
  color: #808080;

  &:hover {
    font-size: 14px;
  }

  ${media.phone`
    font-size: 12px;

    &:hover {
      font-size: 12px;
    }
  `}
`;

export {
  OwnBtn,
  HeaderOwn
};



// WEBPACK FOOTER //
// ./src/components/AdList/components/Ad/components/OwnUrl/styles.js